// extracted by mini-css-extract-plugin
export var quantityInput = "_nd-0";